import { Dom } from '../../dom/dom';
import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcDialogData, RpcDialogResult, RpcDialogType, RpcDialogKey } from './rpc-dialog-model';

export class RpcDialogClient {
    /**
     * Elements that open a dialog, used for resuming focus
     */
    private static dialogOrigins: { [index: string]: HTMLElement } = {};

    /**
     * The dialog command.
     *
     * @param data the dialog data object.
     * @return Promise<RpcDialogResult> the promise object of dialog result.
     */
    public static dialog(rpc: Rpc, data: RpcDialogData): Promise<RpcDialogResult> {
        if (data.type === RpcDialogType.OpenMessageDialog
            || data.type === RpcDialogType.OpenConfirmationDialog
            || data.type === RpcDialogType.OpenConfirmationListDialog
            || data.type === RpcDialogType.OpenChoiceDialog) {
            // open a dialog, store element that opens it
            const origin = document.activeElement as HTMLElement;
            if (origin) {
                RpcDialogClient.dialogOrigins[data.dialogId] = origin;
            }
        }

        return RpcInboundClient.call(rpc, RpcDialogKey.command, RpcDialogKey.version, data)
            .then((result: RpcDialogResult) => {
                if (data.type === RpcDialogType.Close) {
                    // successfully close a dialog, resume focus
                    RpcDialogClient.resumeFocus(data.dialogId);
                }

                return result;
            });
    }

    /**
     * Resume focus back to the original element that shows the dialog.
     * @param id The id of dialog
     */
    private static resumeFocus(id: string): void {
        if (!RpcDialogClient.dialogOrigins[id]) {
            return;
        }

        const element = RpcDialogClient.dialogOrigins[id];
        setTimeout(() => {
            const focusOn: HTMLElement = Dom.getFocusOrigin(element);
            if (focusOn) {
                focusOn.focus();
            }
            delete RpcDialogClient.dialogOrigins[id];
        });
    }
}
